import { render, staticRenderFns } from "./QuotaDialog.vue?vue&type=template&id=95c2b61e&scoped=true"
import script from "./QuotaDialog.vue?vue&type=script&lang=js"
export * from "./QuotaDialog.vue?vue&type=script&lang=js"
import style0 from "./QuotaDialog.vue?vue&type=style&index=0&id=95c2b61e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c2b61e",
  null
  
)

export default component.exports